export abstract class Utils {
    //Aquii é definido todos os métodos estáticos,
    // eles são métodos que podem ser chamados sem a necessidade de instanciar a classe

    public static isAdmin() {
        try {
            if (parseInt(sessionStorage.getItem('perfil')) == 3) {
                return true;
            }

        } catch (err) {
            return false;
        }
    }


    public static isLogged() {


    }

    /**
     * Transforma conjunto de dados separados por , em array
     * @param value
     * @returns {string[] | string}
     */
    public static explode(value) {
        return value != '' && value != null ? value.split(",") : '';
    }

    public static sair() {
        localStorage.clear();
        sessionStorage.clear();
    }

    public static buildParams(params?: any): URLSearchParams {
        let search = new URLSearchParams();

        if (typeof params !== 'undefined') {
            for (let i in params) {
                if (params[i] !== undefined) {
                    if ((i == 'criado_em_to' || i == 'criado_em_from')) {
                        let regex: any = /\d\d\/\d\d\/\d\d\d\d/;
                        if (!regex.test(params[i]))
                            continue;
                    }
                    search.set(i, params[i]);
                }
            }
        }
        return search;
    }


    public static ValidarCPF(strCPF: string): boolean {
        let Soma;
        let Resto;
        Soma = 0;
        if (strCPF == '00000000000') return false;

        for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);

        Resto = (Soma * 10) % 11;

        if ((Resto == 10) || (Resto == 11)) Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10))) return false;

        Soma = 0;

        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);

        Resto = (Soma * 10) % 11;

        if ((Resto == 10) || (Resto == 11)) Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11))) return false;
        return true;
    }

    public static buildFormData(object: any): FormData {
        let formData: FormData = new FormData();
        for (let doc in object) {
            if (typeof(object[doc]) === 'object') {
                if (object[doc] instanceof File) {
                    formData.append(doc, object[doc], object[doc].name);
                } else {
                    this.buildFormDataRec(formData, object, doc, doc);

                }
            } else {
                formData.append(doc, object[doc]);
            }
        }

        return formData;
    }

    private static buildFormDataRec(formData: FormData, object: any, index: any, label: any): void {
        for (let i in object[index]) {
            if (typeof(object[index][i]) === 'object') {
                let l: string = label + '[' + i + ']';
                if (object[index][i] instanceof File) {
                    formData.append(label + '[' + i + ']', object[index][i], object[index][i].name);
                } else {
                    this.buildFormDataRec(formData, object[index], i, l);
                }
            } else {
                formData.append(label + '[' + i + ']', object[index][i]);
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/utils.ts